import React from 'react';
import { Send } from 'lucide-react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../ui/dialog';

export const EmailPreparationModal = ({
    open,
    onOpenChange,
    recipient,
    onRecipientChange,
    sending,
    onSend,
    stockData,
}) => (
    <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="sm:max-w-md" data-testid="email-preparation-modal">
            <DialogHeader>
                <DialogTitle className="flex items-center gap-2 text-jungle">
                    <Send className="w-5 h-5" />
                    Envoyer la preparation de commande
                </DialogTitle>
            </DialogHeader>
            <div className="space-y-4 py-4">
                <div className="space-y-2">
                    <Label htmlFor="recipient_email">Adresse email du destinataire</Label>
                    <Input
                        id="recipient_email"
                        type="email"
                        placeholder="preparateur@entreprise.fr"
                        value={recipient}
                        onChange={(e) => onRecipientChange(e.target.value)}
                        data-testid="email-recipient-input"
                        onKeyDown={(e) => e.key === 'Enter' && onSend()}
                    />
                </div>
                {stockData && (
                    <p className="text-sm text-muted-foreground">
                        {stockData.orders_count} commande(s) | {stockData.stock_items?.length} produit(s)
                    </p>
                )}
            </div>
            <DialogFooter>
                <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
                <Button onClick={onSend} disabled={sending} className="bg-jungle hover:bg-jungle/90 text-white" data-testid="send-email-btn">
                    <Send className="w-4 h-4 mr-2" />
                    {sending ? 'Envoi en cours...' : 'Envoyer'}
                </Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
);
